module.exports = __webpack_public_path__ + "img/e24c6e7.jpg";